// extracted by mini-css-extract-plugin
export var iconArrow = "Navigation-module--icon-arrow--165ca";
export var iconGrid = "Navigation-module--icon-grid--e39fb";
export var link = "Navigation-module--link--9a64b";
export var list = "Navigation-module--list--bc57c";
export var navigation = "Navigation-module--navigation--11f36";
export var subNavigation = "Navigation-module--sub-navigation--b54de";